export enum SnackbarType {
  success = "success",
  error = "error",
}
